import { Locale } from '@suntex.fim/enums'
import { createLocalization, resolveLocale } from '@suntex.fim/utils'

export function getLocale(): Locale {
  return resolveLocale(
    typeof window !== 'undefined' ? window.location.hostname : '',
    String(import.meta.env.VITE_REGION || 'IN')
  )
}

export function getLocalization() {
  return createLocalization(getLocale())
}
